// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3M8Xr","head":"Table_head__1O73s","col":"Table_col__3E0wK"};